import OperationsController from "../adapters/user.controller";

const getRandomComments = async(payload) =>{
    const response = await OperationsController.getRandomComments(payload)
    return response;
}


export default getRandomComments;